import BannerHero from "@/components/bannerHero";
import ContactSection from "@/components/ContactArea";
import NewsSection from "@/components/home/NewsSection";
import Newspage from "@/components/news/news";
import UnderConstruction from "@/components/UnderConstruction";

export default function Event() {
  return (
    <>
      <BannerHero
                title="Our News"
                bgImage="/images/news/news.png"
                className="news-bg" />
        {/* <div className="shape-ellips">
               <Image src="/images/shape.png" alt="shape" fill className="position-relative"/>
             </div> */}
         <UnderConstruction />
        
       {/* <section className="eventspace">< Newspage/></section> */}

     {/* <ContactSection/> */}
    </>
  );
}
 